import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router';

export default function AuthLayout() {
  return (
    <>
      <Helmet>
        <meta
          name='theme-color'
          content='#000000'
        />
      </Helmet>

      <div className='flex flex-col justify-center pt-safe flex-1 items-center bg-gradient'>
        <Outlet />
      </div>
    </>
  );
}
